import { render } from "./EditReservation.vue?vue&type=template&id=b9c0f1da"
import script from "./EditReservation.vue?vue&type=script&lang=ts"
export * from "./EditReservation.vue?vue&type=script&lang=ts"
script.render = render

export default script